module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/bellNew-02f9f5c0cf1dc7e060f030ed1f52faab.svg";